/**
 * ChannelRulesList - Channel-Liste gruppiert nach Integration
 */

import { cn } from '@/lib/utils'
import { ChannelRulesOverview } from './ChannelRulesOverview'

interface Channel {
  id: string
  channel_name: string
  channel_type?: number
  imageRuleCount: number
  textRuleCount: number
  integration_name?: string
}

interface ChannelRulesListProps {
  channels: Channel[]
  selectedId: string | null
  onSelect: (id: string) => void
  isLoading?: boolean
}

function groupByIntegration(channels: Channel[]) {
  const groups: Record<string, Channel[]> = {}
  for (const ch of channels) {
    const key = ch.integration_name || 'Unbekannt'
    if (!groups[key]) groups[key] = []
    groups[key].push(ch)
  }
  return groups
}

export function ChannelRulesList({
  channels,
  selectedId,
  onSelect,
  isLoading,
}: ChannelRulesListProps) {
  if (isLoading) {
    return <div className="text-sm text-neutral-500 p-4">Channels laden...</div>
  }

  if (channels.length === 0) {
    return (
      <div className="text-sm text-neutral-500 p-4 text-center">
        Keine Channels vorhanden. Erstelle zuerst eine Integration.
      </div>
    )
  }

  const groups = groupByIntegration(channels)

  return (
    <div className="space-y-4">
      {Object.entries(groups).map(([integrationName, chs]) => (
        <div key={integrationName}>
          <div className="text-xs font-medium text-neutral-400 dark:text-neutral-500 uppercase tracking-wider mb-2 px-2">
            {integrationName}
          </div>
          <div className="space-y-1">
            {chs.map((ch) => (
              <button
                key={ch.id}
                onClick={() => onSelect(ch.id)}
                className={cn(
                  'w-full text-left px-3 py-3 rounded-lg transition-colors',
                  selectedId === ch.id
                    ? 'bg-primary-50 dark:bg-primary-900/20 border border-primary-200 dark:border-primary-800'
                    : 'hover:bg-neutral-50 dark:hover:bg-neutral-800 border border-transparent'
                )}
              >
                <div className="font-medium text-sm text-neutral-900 dark:text-neutral-100">
                  {ch.channel_name}
                </div>
                <div className="mt-1">
                  <ChannelRulesOverview
                    imageRuleCount={ch.imageRuleCount}
                    textRuleCount={ch.textRuleCount}
                  />
                </div>
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  )
}
